import PusherClient, { Channel, Pusher } from 'pusher-js';

import { setSocketID } from './common';

let pusher: Pusher;

export enum Channels {
  MY_ENTITY,
}

export const getChannelName = (channelType: Channels, businessUuid: string, userUuid: string) => {
  switch (channelType) {
    case Channels.MY_ENTITY:
      return `source-${businessUuid}-user-${userUuid}`;

    default:
      return '';
  }
};

export enum Events {
  ONBOARDING = 'ONBOARDING',
}

export const connectPusher = () => {
  pusher = new PusherClient(process.env.REACT_APP_PUSHER_API_KEY, {
    cluster: 'us3',
    forceTLS: true,
    encrypted: true,
    authTransport: 'jsonp',
    authEndpoint: process.env.REACT_APP_SERVER_URL + '/pusher_authentication',
  });

  pusher.connection.bind('connected', () => {
    setSocketID(pusher.connection.socket_id);
  });
};

export const subscribe = (channelName: string) => {
  if (!pusher) {
    return;
  }

  return pusher.subscribe(channelName);
};

export const addPusherEventListener = (
  channel: Channel,
  eventName: string,
  actionType: string,
  // tslint:disable-next-line: no-any - Type any is intentional here
  callback?: (data: { [key: string]: any }) => Promise<ReduxAction | void> | void | ReduxAction
) => {
  if (!channel) {
    return;
  }
  channel.bind(eventName, data => {
    if (callback) {
      callback(data);
    }

    if (actionType) {
      // store.dispatch({ type: actionType, payload: data });
    }
  });
};

export const removePusherEventListener = (
  channel: Channel,
  eventName: string,
  // tslint:disable-next-line: no-any - Type any is intentional here
  handler?: (data: { [key: string]: any }) => Promise<ReduxAction | void> | void | ReduxAction
) => {
  if (!channel) {
    return;
  }
  channel.unbind(eventName, handler || null);
};

export const unsubscribe = (channelName: string) => {
  if (!pusher) {
    return;
  }

  pusher.unsubscribe(channelName);
};

export const disconnectPusher = () => {
  if (!pusher) {
    return;
  }

  pusher.disconnect();
};
